var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIeSquareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V43H11.2589V37.1335H5.96244V5.86645H11.2589V0H0Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.741 0V5.86645H43.0374V37.1335H37.741V43H48.9995L48.9999 0H37.741Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9102 21.5032L24.5 7.1709L16.0898 21.5032C13.8181 25.3735 14.5493 30.2083 17.8655 33.2608C19.6668 34.9173 22.0226 35.8295 24.5 35.8295C26.9775 35.8295 29.3335 34.9173 31.1346 33.2608C34.4508 30.208 35.1819 25.3735 32.9102 21.5032ZM27.9691 29.9303C27.0304 30.7944 25.7975 31.2706 24.5 31.2706C23.2026 31.2706 21.9697 30.7944 21.0309 29.9303C19.2984 28.3336 18.9161 25.8073 20.102 23.7825L24.5003 16.2887L28.8987 23.7825C30.0839 25.8073 29.7017 28.3336 27.9691 29.9303Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIeSquareLogo);
export default __webpack_public_path__ + "static/media/ie_square_logo.f0d9e4b2e70110345f1fef5bc579ef6a.svg";
export { ForwardRef as ReactComponent };